export const contributorHomeCopy = {
  fr: {
    hello: "Bonjour, {name}",
    helloNoName: "Bonjour",
    subtitle: "Que voulez-vous faire aujourd'hui ?",
    balanceTitle: "Vos gains disponibles",
    balanceHint: "{rate} F CFA par contribution validée",
    nextStep: "Prochaine étape",
    nextContribute: "Faire valider encore {remaining} contributions",
    nextTest: "Passer le test de qualification",
    nextReview: "Votre test est en cours de correction",
    nextPayout: "Demander votre paiement",
    nextEarn: "Continuer à contribuer pour gagner",
    nextPending: "Paiement de {amount} en cours",
    openEarnings: "Voir mes gains",
    tasksTitle: "Choisissez une tâche",
    otherTasks: "Autres tâches",
    figuresTitle: "Votre activité",
    recorded: "Contributions",
    accepted: "Audios validés",
    transcriptions: "Transcriptions",
    reviews: "Vérifications faites",
    weekTitle: "Ces 7 derniers jours",
    weekTotal: "{count} contributions",
    weekEmpty: "Aucune contribution cette semaine. Une session de 5 minutes suffit pour commencer.",
    dayValue: "{count} le {day}",
    seeAll: "Tout voir",
    loadError: "Impossible de charger votre activité.",
    retry: "Réessayer",
  },
  en: {
    hello: "Hello, {name}",
    helloNoName: "Hello",
    subtitle: "What would you like to do today?",
    balanceTitle: "Your available earnings",
    balanceHint: "{rate} F CFA per validated contribution",
    nextStep: "Next step",
    nextContribute: "Get {remaining} more contributions validated",
    nextTest: "Take the qualification test",
    nextReview: "Your test is being corrected",
    nextPayout: "Request your payout",
    nextEarn: "Keep contributing to earn",
    nextPending: "Payout of {amount} in progress",
    openEarnings: "See my earnings",
    tasksTitle: "Choose a task",
    otherTasks: "Other tasks",
    figuresTitle: "Your activity",
    recorded: "Contributions",
    accepted: "Validated recordings",
    transcriptions: "Transcriptions",
    reviews: "Reviews done",
    weekTitle: "Last 7 days",
    weekTotal: "{count} contributions",
    weekEmpty: "No contribution this week. A 5-minute session is enough to start.",
    dayValue: "{count} on {day}",
    seeAll: "See all",
    loadError: "Your activity could not be loaded.",
    retry: "Retry",
  },
} as const;

export type ContributorHomeCopy = { [K in keyof (typeof contributorHomeCopy)["fr"]]: string };
